import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
const KeypadModal = () => {
    let RecordController = useContext(RecordsManagementContext);
    const checkValidation = (e) =>{
        let inputField = document.getElementById("key-pad-val")
        if (RecordController.OtherBedrooms + e.target.id > 20){
            RecordController.setOtherBedrooms('')
            inputField.setAttribute('style', 'border: 2px solid red');
            RecordController.setAlertBox(true)
            RecordController.setIsActive(false)
        }
        else{
            inputField.removeAttribute('style');
            inputField.removeAttribute('placeholder');
            RecordController.setOtherBedrooms(RecordController.OtherBedrooms + e.target.id || e.target.text)
            RecordController.setIsActive(true);
        }
    }
    const keypadClick = (e) => {
        RecordController.setAlertBox(false)
        RecordController.OtherBedrooms >= 0
            ? checkValidation(e) :
            RecordController.setOtherBedrooms(RecordController.OtherBedrooms)
    }
    const clearKeypad = () => {
        RecordController.setAlertBox(false)
        RecordController.OtherBedrooms.toString().length === 2 ? RecordController.setOtherBedrooms(RecordController.OtherBedrooms[0]) : RecordController.setOtherBedrooms('')
    }
    return (
        <>
            <div className="key-design-st" style={{backgroundColor: "whitesmoke"}}>
                <div className="row">
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={1}>1</div>
                    </div>
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={2}>2
                            <div className="sub">ABC</div>
                        </div>
                    </div>
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={3}>3
                            <div className="sub">DEF</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={4}>4
                            <div className="sub">GHI</div>
                        </div>
                    </div>
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={5}>5
                            <div className="sub">JKL</div>
                        </div>
                    </div>
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={6}>6
                            <div className="sub">MNO</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={7}>7
                            <div className="sub">PQRS</div>
                        </div>
                    </div>
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={8}>8
                            <div className="sub">TUV</div>
                        </div>
                    </div>
                    <div className="digit">
                        <div className="no" onClick={(event)=>keypadClick(event)} id={9}>9
                            <div className="sub">WXYZ</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="digit-blank"></div>
                    <div className="digit" onClick={(event)=>keypadClick(event)} id={0}>0</div>
                    <div className="digit-blank" onClick={()=>clearKeypad()} ><img src={"/Images/backspace.png"} className="backspace-img" alt="clear"/></div>
                </div>
            </div>
        </>
    );
}
export default KeypadModal;